import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8 0C3.576 0 0 3.576 0 8s3.576 8 8 8 8-3.576 8-8-3.576-8-8-8m0 14.4A6.41 6.41 0 0 1 1.6 8c0-3.528 2.872-6.4 6.4-6.4s6.4 2.872 6.4 6.4-2.872 6.4-6.4 6.4M10.872 4 8 6.872 5.128 4 4 5.128 6.872 8 4 10.872 5.128 12 8 9.128 10.872 12 12 10.872 9.128 8 12 5.128z" }, null, -1)
  ]))]))
}
export default { render: render }